import Vue from "vue";
import Vuex from "vuex";
import { Project } from "@/api/generated/Project";
import { AgencyProject } from "@/api/generated/AgencyProject";
Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		token: sessionStorage["access_token"] || "",
		loader: false,
		language: "PL",
		evaluationTableFilters: {},
		evaluationTableSortOptions: {},
		dataTableFilters: {},
		dataTablePagination: {},
		projectPanelPermissions: {},
		agencyProjectPanelPermissions: {},
	},

	mutations: {
		loader(state, payload) {
			state.loader = payload;
		},
		language(state, payload) {
			state.language = payload;
		},
		evaluationTableFilters(state, payload) {
			state.evaluationTableFilters = payload;
		},
		evaluationTableSortOptions(state, payload) {
			state.evaluationTableSortOptions = payload;
		},
		dataTableFilters(state, payload) {
			state.dataTableFilters[payload.component] = payload.filters;
		},
		clearDataTableFilters(state) {
			state.dataTableFilters = {};
		},
		dataTablePagination(state, payload) {
			state.dataTablePagination[payload.component] = payload.pagination;
		},
		clearDataTablePagination(state) {
			state.dataTablePagination = {};
		},
		loadProjectPanelPermissions(state, payload) {
			if(!state.projectPanelPermissions.permissionsLoaded || (state.projectPanelPermissions.projectId != payload.projectId)){
				Project.getPanelPermissionsForUser(payload.context, payload.projectId, successResonse => {
					state.projectPanelPermissions = successResonse;
					state.projectPanelPermissions.permissionsLoaded = true;
					state.projectPanelPermissions.projectId = payload.projectId; 
				});
			  }
		},
		loadAgencyProjectPanelPermissions(state, payload) {
			if(!state.agencyProjectPanelPermissions.permissionsLoaded || (state.agencyProjectPanelPermissions.projectId != payload.projectId)){
				AgencyProject.getPanelPermissionsForUser(payload.context, payload.projectId, successResonse => {
					state.agencyProjectPanelPermissions = successResonse;
					state.agencyProjectPanelPermissions.permissionsLoaded = true;
					state.agencyProjectPanelPermissions.projectId = payload.projectId; 
				});
			  }
		},
	},
});
